import { action, computed, makeObservable, observable } from 'mobx';
import { FullAgency } from 'types/aaaService';

export interface ParentStore {
  allSponsorAgencies: FullAgency[];
  getInitialData(): Promise<void>;
}

interface CreationParams {
  parentStore: ParentStore;
}

export class SearchAgencyDelegate {
  private _parentStore: ParentStore;
  private _filteredSponsorAgencies: FullAgency[] = [];

  public get allSponsorAgencies(): FullAgency[] {
    return this._parentStore.allSponsorAgencies;
  }

  public get filteredSponsorAgencies(): FullAgency[] {
    return this._filteredSponsorAgencies;
  }

  /**
   * Searches for agencies based on the provided search value within the available agency collection.
   * Updates array with matching agencies.
   * */
  public searchAgencyByName(searchValue: string): void {
    this._filteredSponsorAgencies = this.allSponsorAgencies.filter((agency) =>
      agency.name.toLowerCase().includes(searchValue.toLowerCase()),
    );
  }

  public resetSearchValue(): void {
    this._filteredSponsorAgencies = [];
  }

  constructor({ parentStore }: CreationParams) {
    this._parentStore = parentStore;

    makeObservable<SearchAgencyDelegate, '_filteredSponsorAgencies'>(this, {
      _filteredSponsorAgencies: observable,
      filteredSponsorAgencies: computed,
      allSponsorAgencies: computed,
      searchAgencyByName: action.bound,
      resetSearchValue: action.bound,
    });
  }
}
